<template>
	<div class="tab-bar f-a">
		<div class="item flex1 f-a-j pointer" :class="{active:tabs_index==index}"
		v-for="(item, index) in header" @click="to(item)">
			<div>{{ $store.state.language=='cn'?item.title:item.title_en }}</div>
		</div>
		
	</div>
</template>

<script>
export default {
	data() {
		return {
			header: [
				{
					title: '首页',
					title_en:'Home',
					path:'/home'
				},
				{
					title: '产品',
					title_en:'Product',
					path: '/category'
				},
				{
					title: '品牌',
					title_en:'Brand',
					path: '/brand'
				},
				{
					title: '防伪查询',
					title_en:'Verify',
					path: '/verify'
				}
			],
			tabs_index:0
		};
	},
	watch:{
		'$route':function(val){
			this.header.forEach((item,index)=>{
				if(val.path.indexOf(item.path)>=0){
					this.tabs_index=index
				}
			})
		}
	},
	created() {
		// this._isMobile()
	},
	methods: {
		to(item) {
			
			this.$router.push({
				path: item.path
			});
		},
		changeLanguage(){
			this.$store.state.language=this.$store.state.language=='cn'?'en':'cn'
		},
		hasActive(path){
			
		}
	}
};
</script>

<style lang="less" scoped>
.tab-bar {
	position: fixed;
	bottom:0;
	left:0;
	background-color: #fff;
	width: 100%;
	z-index: 99999;
	border-top:1px solid rgba(0, 0, 0, 0.125);
	.item {
		height: 50px;
		border-bottom: 2px solid transparent;
	}
	.item:hover {
		background-color: #eaeaea;
	}
	.active{
		
		background-color: #eaeaea;
	}
	.list{
		width: 100%;
	}
}
</style>
